import PositionDto from "../Positions/PositionDto";

export default class CreateContactRequest  {
	firstName = '';  
    lastName = '';
    emailAddress = '';
    isAgreedToMarketing = true;
    mobilePhoneNumber = '';
    otherPhoneNumber = '';
    positionId = '';
    jobTitle = '';
    locationIds: string[] = [];
    // canManageProfile: boolean;
    // canManageReports: boolean;
    // canManageContacts: boolean;
    // canManageRoles: boolean;
    // canManageLocations: boolean;
    // canManageBookings: boolean;
    // canManageWorkers: boolean;
    // canManageTimesheets: boolean;	
}